export const admin = {
  "admin.title": "Suji Admin",
  "admin.checking_permissions": "Vérification des permissions...",
  "admin.suppliers": "Fournisseurs",
  "admin.users": "Utilisateurs",
  "admin.reviews": "Avis",
  "admin.total_revenue": "Revenu Total",
  "admin.pending_suppliers": "Fournisseurs en attente",
  "admin.name": "Nom",
  "admin.email": "Email",
  "admin.category": "Catégorie",
  "admin.actions": "Actions",
  "admin.approve": "Approuver",
  "admin.reject": "Rejeter",
  "admin.no_pending_suppliers": "Aucun fournisseur en attente",
  "admin.confirm_reject": "Êtes-vous sûr de vouloir rejeter ce fournisseur ? Cette action est irréversible.",
  "admin.recent_activity": "Activité récente",
  "admin.latest_reviews": "Derniers avis",
  "admin.no_reviews": "Aucun avis",
  "admin.category_management": "Gestion des catégories",
  "admin.delete_category": "Supprimer la catégorie",
  "admin.init_categories": "Initialiser les catégories",
  "admin.add_category": "Ajouter une catégorie",
  "admin.new_category": "Nouvelle catégorie",
  "admin.edit_category": "Modifier la catégorie",
  "admin.category_name": "Nom de la catégorie",
  "admin.icon": "Icône",
  "admin.description": "Description",
  "admin.display_order": "Ordre d'affichage",
  "admin.placeholder_category": "Entrez le nom de la catégorie",
  "admin.placeholder_icon": "Entrez la classe d'icône Remix",
  "admin.placeholder_description": "Entrez la description de la catégorie",
  "admin.active": "Actif",
  "admin.inactive": "Inactif",
  "admin.add": "Ajouter",
  "admin.cancel": "Annuler",
  "admin.save": "Sauvegarder",
  "admin.edit": "Modifier",
  "admin.delete": "Supprimer",
  "admin.confirm_delete": "Êtes-vous sûr de vouloir supprimer cette catégorie ?",
  "admin.confirm_init": "Êtes-vous sûr de vouloir initialiser les catégories ? Cela ajoutera les catégories par défaut si elles n'existent pas.",
  "admin.init_success": "Catégories initialisées avec succès !",
  "admin.name_required": "Le nom de la catégorie est requis",
  "admin.category_added_success": "Catégorie ajoutée avec succès",
  "admin.error_add_category": "Erreur lors de l'ajout de la catégorie",
  "admin.category_updated_success": "Catégorie mise à jour avec succès",
  "admin.error_update_category": "Erreur lors de la mise à jour de la catégorie",
  "admin.category_deleted_success": "Catégorie supprimée avec succès",
  "admin.error_delete_category": "Erreur lors de la suppression de la catégorie",
  "admin.overview": "Aperçu",
  "admin.overview_description": "Gérez votre plateforme et suivez vos performances en temps réel.",
  "admin.supplier_management": "Gestion des fournisseurs",
  "admin.supplier_management_description": "Approuvez ou rejetez les demandes de fournisseurs.",
  "admin.category_management_description": "Gérez les catégories d'entreprises sur la plateforme.",
  "admin.premium_suppliers": "Fournisseurs Premium",
  "admin.premium_suppliers_description": "Gérez les fournisseurs premium affichés sur la page d'accueil.",
  "admin.all_premium_suppliers": "Tous les fournisseurs premium",
  "admin.premium_status": "Statut premium",
  "admin.set_premium": "Définir premium",
  "admin.remove_premium": "Retirer premium",
  "admin.premium": "Premium",
  "admin.not_premium": "Pas premium",
  "admin.featured": "Mis en vedette",
  "admin.not_featured": "Non mis en vedette",
  "admin.no_premium_suppliers": "Aucun fournisseur premium",
  "admin.error_approve_supplier": "Erreur lors de l'approbation du fournisseur",
  "admin.error_reject_supplier": "Erreur lors du rejet du fournisseur",
  "admin.error_delete_supplier": "Erreur lors de la suppression du fournisseur",
  "admin.error_init_categories": "Erreur lors de l'initialisation des catégories",
  "admin.error_set_featured": "Erreur lors de la mise en vedette",
  "admin.error_remove_featured": "Erreur lors du retrait des vedettes",
  "admin.admin_panel": "Panneau Admin",
  "admin.all_suppliers": "Tous les fournisseurs",
  "admin.total_suppliers": "Fournisseurs totaux",
  "admin.status": "Statut",
  "admin.approved": "Approuvé",
  "admin.pending": "En attente",
  "admin.verified": "Vérifié",
  "admin.yes": "Oui",
  "admin.no": "Non",
  "admin.view": "Voir",
  "admin.feature": "Mettre en vedette",
  "admin.unfeature": "Retirer des vedettes",
  "admin.no_suppliers": "Aucun fournisseur",
  "admin.supplier_details": "Détails du fournisseur",
  "admin.location": "Emplacement",
  "admin.phone": "Téléphone",
  "admin.website": "Site web",
  "admin.created_at": "Créé le",
  "admin.updated_at": "Mis à jour le",
  "admin.close": "Fermer",
  "admin.confirm_delete_supplier": "Êtes-vous sûr de vouloir supprimer ce fournisseur ? Cette action est irréversible.",
  "admin.confirm": "Confirmer",
  "admin.approve_supplier": "Approuver le fournisseur",
  "admin.confirm_approve_supplier": "Êtes-vous sûr de vouloir approuver ce fournisseur ?",
  "admin.supplier_approved": "Fournisseur approuvé avec succès",
  "admin.supplier_featured": "Fournisseur mis en vedette",
  "admin.supplier_unfeatured": "Fournisseur retiré des vedettes",
  "admin.delete_supplier": "Supprimer le fournisseur",
  "admin.supplier_deleted": "Fournisseur supprimé avec succès",
  "admin.no_categories": "Aucune catégorie",
  "admin.category_image": "Image de la catégorie",
  "admin.placeholder_image": "Entrez l'URL de l'image",
  "admin.image": "Image",
  "admin.reject_supplier": "Rejeter le fournisseur",
  "admin.supplier_rejected": "Fournisseur rejeté avec succès",
  "admin.products": "Produits",
  "admin.products_description": "Gérez et suivez tous les produits de la plateforme.",
  "admin.galleries": "Galeries",
  "admin.categories": "Catégories",
  "admin.products_management_description": "Suivez et gérez tous les produits de la plateforme.",
  "admin.total_products": "Produits totaux",
  "admin.active_products": "Produits actifs",
  "admin.inactive_products": "Produits inactifs",
  "admin.total_stock": "Stock total",
  "admin.all_products": "Tous les produits",
  "admin.price": "Prix",
  "admin.stock": "Stock",
  "admin.supplier": "Fournisseur",
  "admin.product_details": "Détails du produit",
  "admin.images": "Images",
  "admin.no_products": "Aucun produit",
  "admin.order": "Commande",
  "admin.no_orders": "Aucune commande",
  "admin.delete_all_suppliers": "Supprimer tous les fournisseurs",
  "admin.confirm_delete_all_suppliers": "Êtes-vous sûr de vouloir supprimer TOUS les fournisseurs ? Cette action est irréversible et supprimera toutes les données fournisseurs de la plateforme.",
  "admin.delete_all_suppliers_success": "Tous les fournisseurs supprimés avec succès",
  "admin.error_delete_all_suppliers": "Erreur lors de la suppression de tous les fournisseurs",
  "admin.init_categories_disabled": "L'initialisation des catégories est désactivée",
  "admin.refresh": "Rafraîchir",
  "admin.refresh_suppliers": "Rafraîchir la liste des fournisseurs",
  "admin.suppliers_refreshed": "Liste des fournisseurs rafraîchie",
  
  "admin.search_icons": "Rechercher des icônes...",
  "admin.image_url_placeholder": "https://exemple.com/image.jpg",
  "admin.notification_title": "Titre de la notification",
  "admin.notification_message": "Message",
  "admin.notification_type": "Type",
  "admin.send": "Envoyer",
  "admin.sending": "Envoi...",
  "admin.send_notification": "Envoyer une notification",
  "admin.notifications": "Notifications",
  "admin.type_system": "Système",
  "admin.type_order": "Commande",
  "admin.type_review": "Avis",
  "admin.type_message": "Message",
  "admin.type_verification": "Vérification",
  "admin.type_approval": "Approbation",
  "admin.all_users": "Tous les utilisateurs",
  "admin.filter_by_category": "Filtrer par catégorie",
  "admin.notifications_history": "Historique des notifications",
  "admin.date": "Date",
  "admin.sent_by": "Envoyé par",
  "admin.sent_to": "Envoyé à",
  "admin.preview": "Aperçu",
  "admin.sent": "Envoyé",
  "admin.no_notifications": "Aucune notification",
  "admin.user": "Utilisateur",
  "admin.recipient_type": "Type de destinataire",
  "admin.select_type": "Sélectionner le type",
  "admin.fill_all_fields": "Veuillez remplir tous les champs",
  "admin.notification_sent": "Notification envoyée avec succès",
  "admin.error_sending_notification": "Erreur lors de l'envoi de la notification",
  "admin.error_fetching_notifications": "Erreur lors de la récupération des notifications",
  "admin.notification_title_placeholder": "Ex. Annonce d'une nouvelle fonctionnalité",
  "admin.notification_message_placeholder": "Contenu de la notification",
  "admin.action_link": "Lien d'action (optionnel)",
  "admin.notification_url_placeholder": "/dashboard ou https://…",
  "admin.send_to_all_users": "Envoyer à tous les utilisateurs",
  "admin.send_notification_button": "Envoyer la notification",
  "admin.notification_sent_to_count": "Notification envoyée à {{count}} utilisateurs",
  "admin.select_user_or_all": "Veuillez sélectionner un destinataire ou cocher « Envoyer à tous les utilisateurs »",
  "admin.user_search": "Destinataire",
  "admin.user_search_placeholder": "Rechercher par nom ou email...",
  "admin.user_search_help": "Tapez au moins 2 caractères (nom ou email), puis sélectionnez l'utilisateur dans la liste.",
  "admin.user_search_no_results": "Aucun utilisateur trouvé",
  "admin.user_search_min_chars": "Tapez au moins 2 caractères pour rechercher",
  "admin.user_search_error": "Erreur lors de la recherche. Réessayez dans un instant.",
  "admin.user_without_name": "Utilisateur sans nom",

  // Newsletter & emails (onglet admin)
  "admin.newsletter": "Newsletter & Emails",
  "admin.newsletter_description": "Envoyez des campagnes aux abonnés de la newsletter et suivez la délivrabilité des emails.",
  "admin.newsletter_campaign": "Envoyer une campagne",
  "admin.newsletter_subject": "Objet",
  "admin.newsletter_subject_placeholder": "Objet de votre campagne",
  "admin.newsletter_content": "Contenu (HTML)",
  "admin.newsletter_content_placeholder": "Contenu HTML de la campagne",
  "admin.newsletter_send": "Envoyer la campagne",
  "admin.newsletter_sent": "Campagne planifiée pour {{count}} abonnés",
  "admin.newsletter_send_error": "Erreur lors de l'envoi de la campagne",
  "admin.newsletter_fields_required": "L'objet et le contenu sont requis",
  "admin.newsletter_subscribers": "Abonnés",
  "admin.newsletter_filter_active": "Actifs",
  "admin.newsletter_filter_unsubscribed": "Désabonnés",
  "admin.newsletter_no_subscribers": "Aucun abonné",
  "admin.newsletter_sector": "Secteur",
  "admin.newsletter_subscribed_at": "Inscrit le",
  "admin.newsletter_status_active": "Actif",
  "admin.newsletter_status_unsubscribed": "Désabonné",
  "admin.email_log": "Journal d'envoi des emails",
  "admin.email_log_recipient": "Destinataire",
  "admin.email_log_subject": "Objet",
  "admin.email_log_error": "Erreur",
  "admin.email_log_failed": "Échec",
  "admin.email_log_sent_total": "Emails envoyés",
  "admin.email_log_failed_total": "Emails en échec",
  "admin.email_log_empty": "Aucun email journalisé pour le moment",
  "admin.email_log_filter_sent": "Envoyés seulement",
  "admin.email_log_filter_failed": "Échecs seulement",

  // Filter and sorting
  "admin.all": "Tous",
  "admin.search": "Recherche",
  "admin.sort_by": "Trier par",
  "admin.reset": "Réinitialiser",
  "admin.all_categories": "Toutes les catégories",
  "admin.search_placeholder": "Rechercher par nom, email, ville...",
  "admin.search_categories_placeholder": "Rechercher par nom ou description...",
  "admin.search_products_placeholder": "Rechercher par nom ou description...",
  "admin.newest_first": "Plus récents d'abord",
  "admin.oldest_first": "Plus anciens d'abord",
  "admin.name_az": "Nom (A-Z)",
  "admin.name_za": "Nom (Z-A)",
  "admin.category_az": "Catégorie (A-Z)",
  "admin.city_az": "Ville (A-Z)",
  "admin.price_low_high": "Prix (croissant)",
  "admin.price_high_low": "Prix (décroissant)",
  "admin.stock_low_high": "Stock (croissant)",
  "admin.stock_high_low": "Stock (décroissant)",
  "admin.out_of_stock": "Rupture de stock"
};

export default admin;